<template>
  <div>
    <div v-for="[place, percent] of top5" :key="place.grid" class="flex items-stretch p-4 border-b border-line">
      <div class="w-8/12 flex flex-col justify-between items-stretch py-2">
        <div class="mb-1">{{place.name}}</div>
        <div class="relative h-2">
          <div class="absolute bg-line h-full" :style="{width: `${percent}%`}"></div>
        </div>
      </div>
      <div class="ml-auto leading-none self-end">
        <span class="text-5xl leading-none">{{percent}}</span>%
      </div>
    </div>
  </div>
</template>

<script>
import { reverseLookup } from '@/services/places'
import { loadWordData } from "@/services/mapdata"

export default {
  data() {
    return {
      top5: []
    }
  },
  props: {
    gsurl: String,
  },
  created() {
    this.computeTop5()
  },
  watch: {
    gsurl() {
      this.computeTop5()
    }
  },
  methods: {
    async computeTop5() {
      loadWordData()
      const data = await loadWordData(this.gsurl)
      const raw = [...data.counter.entries()].sort(([,a], [,b]) => b - a);
      const raw5 = raw.slice(0, 5)
      const other = raw.slice(5)
      const top5 = []

      let totalPercent = 0
      for (const dp of raw5) {
        const city = await reverseLookup(dp[0])
        const percent = Math.round(100* dp[1] / data.total)
        totalPercent += percent
        top5.push([city, percent])
      }
      if(other && totalPercent < 99.5) {
        top5.push([{name: 'Altre località'}, 100-totalPercent])
      }

      this.top5 = top5
    }
  }

}
</script>

<style>

</style>